import React, { Fragment } from "react";
import Hero from "../../components/hero/Hero";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ServiceSection2 from "../../components/ServiceSection2/ServiceSection";
import ServiceSection3 from "../../components/ServiceSection3/ServiceSection";
import ServiceSection4 from "../../components/ServiceSection4/ServiceSection";
import About from "../../components/hero copy/About";
import WhyChoose from "../../components/WhyChoose/WhyChoose";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Pricing from "../../components/Pricing/Pricing";

const HomePage = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing-section");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Fragment>
      <Hero link={scrollToPricing} />
      <ServiceSection link={scrollToPricing} />
      <ServiceSection2 link={scrollToPricing} />
      <ServiceSection4 link={scrollToPricing} />
      <WhyChoose link={scrollToPricing} />
      <ServiceSection3 link={scrollToPricing} />
      <Pricing />
      <About link={scrollToPricing} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HomePage;
